export default function TrainingEffectiveness() {
  const kpis = [
    { icon: 'ri-user-unfollow-line', metric: 'Текучесть персонала', desc: 'Снижение процента увольнений среди ключевых сотрудников и руководителей. Измеряется ежеквартально.' },
    { icon: 'ri-heart-pulse-line', metric: 'Вовлечённость (eNPS)', desc: 'Рост индекса лояльности сотрудников по данным опросов. Прямой показатель качества управления.' },
    { icon: 'ri-bar-chart-2-line', metric: 'Выполнение KPI', desc: 'Увеличение процента достижения плановых показателей отделами и конкретными сотрудниками.' },
    { icon: 'ri-speed-line', metric: 'Скорость принятия решений', desc: 'Сокращение времени от постановки задачи до её реализации. Измеряется в днях или часах.' },
    { icon: 'ri-shake-hands-line', metric: 'Количество конфликтов', desc: 'Снижение числа эскалированных конфликтов, жалоб и обращений к вышестоящему руководству.' },
    { icon: 'ri-user-star-line', metric: 'Производительность', desc: 'Рост выручки или объёма выполненных задач на одного сотрудника и на руководителя.' },
    { icon: 'ri-seedling-line', metric: 'Внутренние назначения', desc: 'Увеличение доли руководителей, выросших внутри компании, а не нанятых извне.' },
    { icon: 'ri-emotion-happy-line', metric: 'Удовлетворённость сотрудников', desc: 'Рост общей удовлетворённости работой и условиями по данным регулярных опросов команды.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Как оценить эффективность обучения руководителей
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-4xl mx-auto">
          Обучение руководителей — это инвестиция, которая должна приносить измеримый результат. Вот ключевые показатели, которые меняются после системного тренинга
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {kpis.map((item, i) => (
            <div key={i} className="bg-gray-50 p-6 rounded-xl hover:bg-teal-50 transition-colors group text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{item.metric}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 max-w-3xl mx-auto bg-teal-50 border border-teal-200 rounded-xl p-6 md:p-8">
          <p className="text-teal-800 leading-relaxed text-sm md:text-base">
            <strong>Важно:</strong> Мы рекомендуем проводить замеры до обучения (точка «А») и через 3–6 месяцев после внедрения (точка «Б»). Только так можно объективно оценить эффективность <strong>тренинга для руководителей</strong> и его влияние на бизнес-показатели компании.
          </p>
        </div>
      </div>
    </section>
  );
}